import {
  goHomeIfNoCorrelationId,
  handlePreviousTenantSpecificLoginRoute,
  handleSamlLoginRedirect,
  redirectToSsoLoginIfUsingSso,
} from '@/login/router/guards';
import { IS_PUBLIC, NO_AUTH_NEEDED } from '@/types';

const LoginWelcomeBackPage = () => import('@/login/pages/login-welcome-back.vue');
const LoginUniversalLoginPage = () => import('@/login/pages/login-universal-login.vue');
const LoginFindYourUrlPage = () => import('@/login/pages/login-find-your-url.vue');
const LoginForgotPasswordPage = () => import('@/login/pages/login-forgot-password.vue');
const LoginEmailSentPage = () => import('@/login/pages/login-email-sent.vue');
const LoggedOutPage = () => import('@/login/pages/logged-out.vue');
const LoginPasswordUpdatedPage = () => import('@/login/pages/login-password-updated.vue');
const LoginTokenExpiredPage = () => import('@/login/pages/login-token-expired.vue');
const LoginValidateTokenPage = () => import('@/login/pages/login-validate-token.vue');
const LoginMfaTokenPage = () => import('@/login/pages/login-mfa-token.vue');
const LoginInvitePage = () => import('@/login/pages/login-invite.vue');
const LoginSamlLoginPage = () => import('@/login/pages/login-saml-login.vue');

export const loginRoutes = [
  {
    path: '/login',
    name: 'universal-login',
    component: LoginUniversalLoginPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-login',
    },
    beforeEnter: [handlePreviousTenantSpecificLoginRoute],
  },
  {
    path: '/welcome-back',
    name: 'welcome-back',
    component: LoginWelcomeBackPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
    beforeEnter: [redirectToSsoLoginIfUsingSso],
  },
  {
    path: '/find-your-url',
    name: 'find-your-url',
    component: LoginFindYourUrlPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/loginadmin',
    name: 'login-admin',
    component: LoginWelcomeBackPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  // Forgot password
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: LoginForgotPasswordPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/forgot-password/:token',
    name: 'validate-token',
    component: LoginValidateTokenPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/email-sent',
    name: 'email-sent',
    component: LoginEmailSentPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/logged-out',
    name: 'logged-out',
    component: LoggedOutPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/password-updated',
    name: 'password-updated',
    component: LoginPasswordUpdatedPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/token-expired',
    name: 'token-expired',
    component: LoginTokenExpiredPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  // End forgot password
  {
    path: '/mfa-token',
    name: 'mfa-token',
    component: LoginMfaTokenPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
    beforeEnter: [goHomeIfNoCorrelationId],
  },
  {
    path: '/invite/:id',
    name: 'invite',
    component: LoginInvitePage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/saml/login',
    name: 'saml-login',
    component: LoginSamlLoginPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
    },
    beforeEnter: [handleSamlLoginRedirect],
  },
];
